import { Container, Paper, Typography } from "@material-ui/core";

export default function PrivacyPolicy() {
    return (
        <Container maxWidth="sm">
            <Paper style={{ padding: 20, marginTop: 20 }}>
                <Typography variant="h5">Privatlivspolitik</Typography>

                <Typography style={{ marginTop: 12 }}>
                    Vi gemmer de oplysninger, du giver os (email, kaldenavn og indhold), for at kunne levere tjenesten.
                </Typography>

                <Typography style={{ marginTop: 12 }}>
                    Vi bruger også tekniske data (fx login-sessioner) for at få siden til at fungere.
                </Typography>

                <Typography style={{ marginTop: 12 }}>
                    Du kan kontakte os for indsigt eller sletning af din konto.
                </Typography>

                <Typography style={{ marginTop: 12 }}>Kontakt: nbitecodeteam@gmail.com</Typography>
            </Paper>
        </Container>
    );
}
